module.exports = {"610204001":"永安路街道","610204002":"天宝路街道","610204003":"咸丰路街道","610204004":"正阳路街道","610204005":"锦阳路街道","610204006":"坡头街道","610204101":"董家河镇","610204102":"庙湾镇","610204103":"瑶曲镇","610204104":"照金镇","610204107":"小丘镇","610204108":"孙原镇","610204109":"关庄镇","610204111":"石柱镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610204.json
// module id = 2928
// module chunks = 0